import i18n from 'i18next'

export default {
  categories: () => {
    const categoriesObj = i18n.t('dashboard.themes.categories')
    return Object.keys(categoriesObj).map(key => ({ value: key, text: categoriesObj[key] }))
  },
  filteredThemes: state =>
    state.selectedCategory === 'all'
      ? state.themes.slice()
      : state.themes.filter(theme => theme.category.toLowerCase() == state.selectedCategory),
  languages: () => {
    const localesObj = i18n.t('dashboard.themes.locales')
    return Object.keys(localesObj).map(key => ({ value: key, text: localesObj[key] }))
  },
}
